import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import { useTheme } from "@mui/material";

const SaleCharts = ({ chartData }) => {
  const theme = useTheme();
  // Transform chartData → hourly totals
  const dayinweek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const today = new Date();
  const dayIndex = today.getDay();
  const todayDayName = dayinweek[dayIndex];

  const hourlyData = useMemo(() => {
    if (!chartData || chartData.length === 0) return [];

    // Initialize 24 hours with 0
    const hours = Array.from({ length: 24 }, (_, i) => ({
      hour: `${i.toString().padStart(2, "0")}:00`,
      current: 0
    }));

    chartData.forEach(order => {
      if (!order.startTime || !order.total) return;

      const orderDate = new Date(order.startTime);
      const hour = orderDate.getHours(); // get hour (0–23)

      hours[hour].current += order.total;
    });

    return hours;
  }, [chartData]);

  return (
    // Old
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={hourlyData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="hour"
          label={{ value: "Hour of Day", position: "insideBottom", offset: -5 }}
        />
        <YAxis label={{ value: "Sales", angle: -90, position: "insideLeft" }} />
        <Tooltip />
        <Legend />
        <Bar dataKey="current" fill="#3f51b5" name={todayDayName} />
        {/* Keep line for future comparison if needed */}
        <Line type="monotone" dataKey="previous" stroke="#ff5722" name={`last ${todayDayName}`} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default SaleCharts;
